import { API } from "./axiosInstance"

/**
 * Calls the update applicationMember endpoint
 * @param {*} applicationMember the applicationMember to update
 * @returns the updated applicationMember
 */
export const updateApplicationMember = async (applicationMember) => {
    const updatedApplicationMember = await API.put(`/applicationMember/${applicationMember.id}`, applicationMember);
    return updatedApplicationMember;
}